import Header from './../../../components/Header/BarOther.vue';
import FooterOther from './../../../components/Footer/FooterOther.vue';

import api from '../../../js/api.js';
import 'swiper/dist/css/swiper.css';
import { swiper, swiperSlide } from 'vue-awesome-swiper';

export default {
  name: 'mainww',
  components: { Header, FooterOther },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },

  data() {
    let that = this;
    return {
      cardList: [
        {
          id: 1,
          path: 'https://static.wixstatic.com/media/11062b_06dfa7d722434df3924f579b5be62ae7~mv2.jpeg/v1/fill/w_1568,h_922,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/11062b_06dfa7d722434df3924f579b5be62ae7~mv2.jpeg',
        },
        {
          id: 2,
          path: 'https://static.wixstatic.com/media/11062b_3617dc08bc644a038066bf9f7d2dcc60~mv2.jpg/v1/fill/w_1960,h_1152,al_c,q_90,usm_0.66_1.00_0.01,enc_auto/11062b_3617dc08bc644a038066bf9f7d2dcc60~mv2.jpg',
        },
        {
          id: 3,
          path: 'https://static.wixstatic.com/media/ff94a6c09aff4ad2961bea46a1afad37.jpg/v1/fill/w_1960,h_1152,al_c,q_90,usm_0.66_1.00_0.01,enc_auto/ff94a6c09aff4ad2961bea46a1afad37.jpg',
        },
        {
          id: 4,
          path: 'https://static.wixstatic.com/media/d2418e4ab94246c690f87ebe383e943b.jpg/v1/fill/w_1960,h_1152,al_c,q_90,usm_0.66_1.00_0.01,enc_auto/d2418e4ab94246c690f87ebe383e943b.jpg',
        },
      ],
      email: '',
    };
  },
  mounted() {},
  methods: {
    //  keepTimes(e){ //节流函数，处理滚动到尾部不触发轮播事件
    //     if(this.$refs.mySwiper){
    //         let isEnd = this.$refs.mySwiper.swiper.isEnd
    //         if(isEnd){
    //             this.showFlag = false
    //         }else{
    //             let activeIndex = this.$refs.mySwiper.swiper.activeIndex
    //             if(activeIndex==0){ //排除第一轮，第一轮隐藏

    //             }else{
    //                 this.showFlag = true
    //             }
    //         }
    //     }
    // },
    openUrl() {
      window.open('https://www.minderworks.com/login', '_self');
    },
    goLogin() {},
    swiperchange(i) {
      console.log(100);
    },
  },
};
